/*
 * Modal dialogs
 * Opens a native `<dialog class="modal">` (see snippets/modal.liquid) from any trigger on the page:
 *   - <button type="button" data-modal-open="DialogId" aria-haspopup="dialog" aria-controls="DialogId">
 *   - <a href="#DialogId">
 *
 * The native dialog already traps focus, closes on Escape and returns focus to the trigger;
 * close buttons use `<form method="dialog">` and the scroll lock is CSS. This script only adds
 * opening from triggers (delegated, so triggers can live in any section) and closing on a
 * backdrop click.
 */
const getDialog = (id) => {
  const element = id ? document.getElementById(id) : null;
  return element instanceof HTMLDialogElement && element.classList.contains("modal") ? element : null;
};

document.addEventListener("click", (event) => {
  const trigger = event.target.closest("[data-modal-open], a[href^='#']");
  if (!trigger) return;

  const id = trigger.dataset.modalOpen ?? trigger.getAttribute("href").slice(1);
  const dialog = getDialog(id);
  if (!dialog) return;

  event.preventDefault();
  if (!dialog.open) dialog.showModal();
});

// Backdrop clicks land on the dialog itself (its content sits in an inner wrapper). Both the
// press and the release must hit it, so selecting text and releasing outside doesn't close it.
let pressedDialog = null;

document.addEventListener("pointerdown", (event) => {
  pressedDialog = getDialog(event.target.id) === event.target ? event.target : null;
});

document.addEventListener("click", (event) => {
  if (pressedDialog && event.target === pressedDialog && pressedDialog.open) {
    pressedDialog.close();
  }
  pressedDialog = null;
});
